"use strict";

var Ajaxinate = function (config) {
  var settings = config || {};
  var defaultSettings = {
    pagination:  "#Huratips-Pagination",
    method:      "click",
    container:   ".Huratips-Loop",
    offset:      0,
    loadingText: "<div class='product_loader'><img src='https://cdn.shopify.com/s/files/1/0741/9297/8077/files/loadinBlack.gif?v=1770206790' alt='product loader' width='24' height='24'></div>",
    callback:    null
  };

  this.settings          = Object.assign(defaultSettings, settings);
  this.containerElement  = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);
  this._isLoading        = false;
  this._prefetchCache    = {};
  this._prefetchAbort    = null;
  this._listenerAttached = false;

  this.addClickListener        = this.addClickListener.bind(this);
  this.addScrollListeners      = this.addScrollListeners.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks      = this.stopMultipleClicks.bind(this);
  this.destroy                 = this.destroy.bind(this);

  this.initialize();
};

/* ── INIT ─────────────────────────────────────────────────────────────────── */

Ajaxinate.prototype.initialize = function () {
  if (!this.containerElement || !this.paginationElement) return;

  if (this.settings.method === "scroll") {
    this.addScrollListeners();
  } else {
    this.addClickListener();
  }

  this._prefetch();
};

/* ── PREFETCH ─────────────────────────────────────────────────────────────── */

Ajaxinate.prototype._prefetch = function () {
  var link = this.paginationElement.querySelector("a");
  if (!link || !link.href || this._prefetchCache[link.href]) return;

  if (this._prefetchAbort) this._prefetchAbort.abort();
  this._prefetchAbort = new AbortController();

  var url  = link.href;
  var self = this;

  fetch(url, {
    signal:      this._prefetchAbort.signal,
    credentials: "same-origin"
  })
    .then(function (r) { return r.text(); })
    .then(function (html) { self._prefetchCache[url] = html; })
    .catch(function () {});
};

/* ── BUTTON STATE ─────────────────────────────────────────────────────────── */

Ajaxinate.prototype._disableButton = function () {
  if (!this.nextPageLinkElement) return;
  this._buttonLabel                            = this.nextPageLinkElement.innerHTML;
  this.nextPageLinkElement.innerHTML           = this.settings.loadingText;
  this.nextPageLinkElement.style.pointerEvents = "none";
  this.nextPageLinkElement.setAttribute("aria-disabled", "true");
  this.nextPageLinkElement.setAttribute("disabled", "disabled");
};

Ajaxinate.prototype._enableButton = function () {
  if (!this.nextPageLinkElement) return;
  this.nextPageLinkElement.innerHTML           = this._buttonLabel || "Load More";
  this.nextPageLinkElement.style.pointerEvents = "";
  this.nextPageLinkElement.removeAttribute("aria-disabled");
  this.nextPageLinkElement.removeAttribute("disabled");
};

/* ── LISTENERS ────────────────────────────────────────────────────────────── */

Ajaxinate.prototype.addClickListener = function () {
  var link = this.paginationElement.querySelector("a");
  if (!link) return;

  // Keep reference for button state methods, but attach listener to the
  // stable paginationElement wrapper via delegation — not to the <a> directly.
  this.nextPageLinkElement = link;

  if (!this._listenerAttached) {
    this.paginationElement.addEventListener("click", this.stopMultipleClicks);
    this._listenerAttached = true;
  }
};

Ajaxinate.prototype.addScrollListeners = function () {
  document.addEventListener("scroll",          this.checkIfPaginationInView);
  window.addEventListener("resize",            this.checkIfPaginationInView);
  window.addEventListener("orientationchange", this.checkIfPaginationInView);
};

Ajaxinate.prototype.stopMultipleClicks = function (event) {
  // Only act on clicks that originate from (or bubble through) an <a> tag
  var link = event.target.closest("a");
  if (!link) return;

  event.preventDefault();
  if (this._isLoading) return;

  this._isLoading          = true;
  this.nextPageUrl         = link.href;   // read href from the actual clicked <a>
  this.nextPageLinkElement = link;        // sync reference for _disableButton

  this._disableButton();
  this.loadMore();
};

Ajaxinate.prototype.checkIfPaginationInView = function () {
  var rect   = this.paginationElement.getBoundingClientRect();
  var top    = rect.top    - this.settings.offset;
  var bottom = rect.bottom + this.settings.offset;

  if (top <= window.innerHeight && bottom >= 0 && !this._isLoading) {
    var link = this.paginationElement.querySelector("a");
    if (!link) return;

    this.nextPageLinkElement = link;
    this.nextPageUrl         = link.href;
    this._isLoading          = true;

    this.removeScrollListeners();
    this._disableButton();
    this.loadMore();
  }
};

/* ── LOAD ─────────────────────────────────────────────────────────────────── */

Ajaxinate.prototype.loadMore = function () {
  var self = this;
  var url  = this.nextPageUrl;

  if (this._prefetchCache[url]) {
    var cached = this._prefetchCache[url];
    delete this._prefetchCache[url];
    this._applyContent(this._parse(cached));
    return;
  }

  fetch(url, { credentials: "same-origin" })
    .then(function (r) { return r.text(); })
    .then(function (html) { self._applyContent(self._parse(html)); })
    .catch(function () {
      self._isLoading = false;
      self._enableButton();
    });
};

/* ── APPLY ────────────────────────────────────────────────────────────────── */

Ajaxinate.prototype._applyContent = function (doc) {
  // 1. Append new products via DocumentFragment (single reflow)
  var newContainer = doc.querySelector(this.settings.container);
  if (newContainer) {
    var fragment = document.createDocumentFragment();
    Array.from(newContainer.childNodes).forEach(function (node) {
      fragment.appendChild(node);
    });
    this.containerElement.appendChild(fragment);
  }

  // 2. Swap pagination HTML — only innerHTML is replaced; the wrapper element
  //    (paginationElement) stays in the DOM so the delegated listener remains valid.
  var newPagination = doc.querySelector(this.settings.pagination);
  this.paginationElement.innerHTML = newPagination ? newPagination.innerHTML : "";

  // 3. Reset loading state — do NOT reset _listenerAttached; the delegated
  //    listener on paginationElement is still live and does not need re-attaching.
  this._isLoading = false;

  // 4. Sync nextPageLinkElement to the freshly injected <a> and prefetch next page
  this.nextPageLinkElement = this.paginationElement.querySelector("a");
  this._prefetch();

  // 5. Re-enable button on the now-current link node
  this._enableButton();

  // 6. Optional callback
  if (typeof this.settings.callback === "function") {
    this.settings.callback(doc);
  }
};

/* ── HELPERS ──────────────────────────────────────────────────────────────── */

Ajaxinate.prototype._parse = function (html) {
  return new DOMParser().parseFromString(html, "text/html");
};

/* ── CLEANUP ──────────────────────────────────────────────────────────────── */

Ajaxinate.prototype.removeClickListener = function () {
  if (this.paginationElement) {
    this.paginationElement.removeEventListener("click", this.stopMultipleClicks);
  }
  this._listenerAttached = false;
};

Ajaxinate.prototype.removeScrollListeners = function () {
  document.removeEventListener("scroll",          this.checkIfPaginationInView);
  window.removeEventListener("resize",            this.checkIfPaginationInView);
  window.removeEventListener("orientationchange", this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function () {
  if (this.settings.method === "scroll") {
    this.removeScrollListeners();
  } else {
    this.removeClickListener();
  }
  if (this._prefetchAbort) this._prefetchAbort.abort();
  return this;
};